import { FetchingDiv } from '@shared/ui/fetching-div/fetching-div';
import React, { useMemo } from 'react'
import s from './days-of-week.module.scss'
import { DayCard } from '@features/schedule/ui/day-card/day-card';
import { AnimatePresence } from 'framer-motion';
import { ScheduleItems } from '../schedule-items/schedule-items';
import { ClassCard } from '@features/schedule/ui/class-сard/class-сard';

export const DaysOfWeek = ({appointmentsIsFetched, start_date, end_date, today, isTeacher, groupedTimeSlots, todayRef, todayWithTime, showType, weekClasses, upcoming}) => {
	 const fullDays = useMemo(() => {
    let startDate = new Date(start_date);
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(end_date);
    endDate.setHours(0, 0, 0, 0);

    let days = {};
    while (startDate <= endDate) {
      let dayName = startDate
        .toLocaleString("ru-RU", { weekday: "long" })
        .toLowerCase();
      days[dayName] = new Date(startDate); // Сохраняем объект даты для каждого дня
      startDate.setDate(startDate.getDate() + 1);
    }		

    return days;
  }, [start_date, end_date]);

	return (
			<FetchingDiv isFetching={!appointmentsIsFetched} className={s.weekWrapper}>
				{fullDays &&
					Object?.entries(fullDays)?.map(([dayName, date]) => {
						const weekday = date
							.toLocaleString("en-us", { weekday: "long" })
							.toLowerCase();

						return (
							<DayCard
								key={date + dayName}
								{...{
									date,
									dayName,
									today,
									isTeacher,
									groupedTimeSlots,
									todayRef,
								}}
							>
								<AnimatePresence>
								{isTeacher
									? 
										<ScheduleItems {...{dayName, weekday, weekClasses, groupedTimeSlots, isTeacher, upcoming, start_date, end_date, date, today, todayWithTime, showType}}/>
									: weekClasses[dayName] &&
										weekClasses[dayName].map((cl) => (
											<ClassCard
												isTeacher={isTeacher}
												key={cl?.starts_at}
												isUpcoming={upcoming?.id === cl?.id}
												{...cl}
											/>
										))}
								</AnimatePresence>
							</DayCard>
						);
					})}
			</FetchingDiv>
	)
}
